module.exports = __webpack_public_path__ + "static/media/phase two - 300px.02e9008d.png";